import { FC, useState } from 'react';

import { StateWithInactive } from './../types';

import {
  SnippetReferencesFiltersContext,
  SnippetReferencesFiltersState,
} from './SnippetReferencesFilterContext';

export const SnippetReferencesFilterContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [selectedFilters, setSelectedFilters] = useState<StateWithInactive>([]);

  /**
       Filter-related variables and functions
    */

  const resetFilter = () => {
    setSelectedFilters([] as StateWithInactive);
  };

  const handleFilterChange = (filters: StateWithInactive) => {
    setSelectedFilters(filters);
  };

  const context: SnippetReferencesFiltersState = {
    selectedFilters,
    resetFilter,
    handleFilterChange,
  };

  return (
    <SnippetReferencesFiltersContext.Provider value={context}>
      {children}
    </SnippetReferencesFiltersContext.Provider>
  );
};
